/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "components/MKBox";

// Material Kit 2 React examples
import DefaultInfoCard from "examples/Cards/InfoCards/DefaultInfoCard";

function BudgetEstimate2025_2026Information() {
  return (
    <MKBox component="section" py={12}>
      <Container>
        <Grid container spacing={3} alignItems="center">
          <Grid item xs={12} lg={12} sx={{ ml: "auto", mt: { xs: 3, lg: 0 } }}>
            <DefaultInfoCard
              //icon="info"
              title="Elections Nova Scotia 2025-2026 Budget Estimate"
              description={
                <>
                  <h4>
                    On January 29, 2025, Li Chao, the Chief Financial Officer for Elections Nova Scotia (ENS) presented a budget estimate of $7.523million for the 2025-2026 fiscal year to the Special Committee of the House of Assembly that convenes annually by law to consider the budget submissions of ENS and the Auditor General.
                  </h4>
                  <br /><p>ENS’s 2025-2026 budget submission includes an additional $2.8M, which  is required to continue to fulfill our mandate. This amount includes: </p>
                  <ul style={{ paddingLeft: "40px" }}>
                  <br /><p>1. $1.5M to purchase new IT equipment in preparation for the next election. Approximately 1100 pieces of IT equipment used in the last three general elections have reached the end of their life cycle and must be replaced to ensure security and connectivity. </p>
                  <br /><p>2. $839K to wrap up the 42nd Provincial General Election. Major activities planned for the upcoming fiscal year include compliance review of candidate financial reports, post event debrief, as well as decommission of tech equipment. </p>
                  <br /><p>3. $260K for one potential by-election. This is based on historical occurrence and costs. </p>
                  <br /><p>4. $100K for the outreach strategy to support our inclusion, diversity, equity, and accessibility programing.</p>
                  <br /><p>5. $54K for external legal counsel. </p>
                  </ul>
                  <br /><p>The budget estimate as submitted to the Special Committee and the speaking notes for the Chief Financial Officer are available here for your convenience.</p>
                  <br /><li><u><a href={`${process.env.PUBLIC_URL}/files/ENS_202526_BudgetEstimates_SC_Jan29_2025.pdf`}>2025-2026 Budget Estimates as presented to the Special Committee of the House of Assembly on January 29, 2025</a></u></li>
                  <li><u><a href={`${process.env.PUBLIC_URL}/files/ENS_Budget_SC_CFOSpeakingNotes_Jan 29_2025.pdf`}>Speaking Notes for the Chief Financial Officer as presented to the Special Committee of the House of Assembly on January 29, 2025</a></u></li>
                  <br />
                  <br />
                  ENS is an independent non-partisan agency that reports to the members of the House of Assembly through the Speaker. Its mandate is to deliver provincial elections impartially and professionally.
 
                </>
              }
            />
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default BudgetEstimate2025_2026Information;
